import React from 'react';

/**
 * Compact clickable thumbnail for bank / external-transaction documents.
 * Documents are stored as PDF — preview via iframe (same pattern as before).
 */
const DocumentThumbnail = ({
  url,
  title = 'document',
  width = 100,
  height = 50,
  onClick,
}) => {
  if (!url) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) onClick(e);
    else window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        display: 'inline-block',
        lineHeight: 0,
        width,
        height,
        overflow: 'hidden',
        borderRadius: 4,
      }}
      title={title}
    >
      <iframe
        src={`${url}#page=1`}
        width={width}
        height={height}
        title={title}
        style={{ pointerEvents: 'none', border: 'none', borderRadius: 4 }}
      />
    </div>
  );
};

export default DocumentThumbnail;
